import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Button } from "@mantine/core";
import { Form } from "react-bootstrap";
import FlashcardGrid from "../components/FlashcardGrid";
import AddCard from "../components/AddCard";
import { withAuth } from "./withAuth";
import Header from "../components/Header";
import { API_URL } from "../config";

function FlashcardSetEditor({ sets, setSets }) {
  const [flashcardSet, setFlashcardSet] = useState(null);
  const [title, setTitle] = useState("");
  const [newTitle, setNewTitle] = useState("");
  const [flashcards, setFlashcards] = useState([]);
  const [front, setFront] = useState("");
  const [back, setBack] = useState("");
  const navigate = useNavigate();
  const params = useParams();
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    axios
      .get(`${API_URL}/set/${userId}/${params.id}`)
      .then((response) => {
        setFlashcardSet(response.data.data[0]);
        setFlashcards(response.data.data[0].flashcards);
        setTitle(response.data.data[0].title);
      })
      .catch((error) => console.error(error));
  }, [params.id]);

  const handleDefaultSubmit = (event) => {
    event.preventDefault();
  };

  const handleTitleChange = (event) => {
    event.preventDefault();
    setNewTitle(event.target.value);
  };

  function handleSave() {
    axios
      .put(`${API_URL}/set/${params.id}`, {
        title: newTitle,
      })
      .then((response) => {
        const updatedSet = response.data.data;
        const updatedSets = sets.map((set) => {
          if (set._id === updatedSet._id) {
            return updatedSet;
          }
          return set;
        });
        console.log(updatedSets);
        setSets(updatedSets);
        navigate("/");
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const onDeleteClick = (setId, cardId) => {
    console.log("delete button clicked!");
    const updatedCards = flashcards.filter((card) => card._id !== cardId);
    setFlashcards(updatedCards);
    axios
      .delete(`${API_URL}/set/${setId}/${cardId}`)
      .catch((error) => {
        console.error(error);
      });
  };

  const onSubmit = () => {
    axios
      .post(`${API_URL}/set/${params.id}/`, {
        front: front,
        back: back,
      })
      .then((response) => {
        const newCard = response.data.data;
        setFlashcards([...flashcards, newCard]);
      })
      .catch((error) => {
        console.error(error);
      });
    setFront("");
    setBack("");
  };

  return (
    <>
      <Header />
      <div
        className="container"
        style={{
          display: "flex",
          position: "absolute",
          width: "100vh",
          height: "200px",
          marginTop: "2rem",
          top: "10%",
          left: "20%",
          gridTemplateColumns: "repeat(1fr, 2fr)",
          gridColumnGap: "20px",
          gridRowGap: "5px",
        }}
      >
        <AddCard
          front={front}
          back={back}
          setFront={setFront}
          setBack={setBack}
          onSubmit={onSubmit}
        />
        <Card
          shadow="md"
          style={{
            borderRadius: "10px",
            width: "50%",
            maxWidth: "400px",
            margin: "auto auto",
            height: "240px",
          }}
        >
          <Form onChange={handleTitleChange} onSubmit={handleDefaultSubmit}>
            <Form.Group>
              <Form.Label>Set Name</Form.Label>
              <Form.Control name="title" defaultValue={title} />
              <Form.Label></Form.Label>
            </Form.Group>
            <Button
              size="lg"
              color="red"
              className="w-100"
              variant="light"
              onClick={() => navigate("/")}
            >
              Cancel
            </Button>
            <Button
              size="lg"
              color="green"
              className="w-100"
              variant="light"
              style={{ marginTop: "10px" }}
              onClick={handleSave}
            >
              Save
            </Button>
          </Form>
        </Card>
      </div>
      <div>
        <FlashcardGrid
          setId={params.id}
          onDeleteClick={onDeleteClick}
          flashcards={flashcards}
        />
      </div>
    </>
  );
}

export default withAuth(FlashcardSetEditor);
